module.exports = __webpack_public_path__ + "media/images/sad-smile-icon-6649e848878168cd8dbe750ffa366198.png";